import { ControlledSelect, ControlledTextarea } from '@/components/controlled';
import { getSelectOptions, nameof } from '@/functions';
import { useFormContext } from 'react-hook-form';
import { LabelRequired } from '@/components/hoc';
import { TFormData } from '.';

const FormCommentReviewBody = () => {

  const { control, formState: { isSubmitting } } = useFormContext<TFormData>();

  return (
    <div className='py-3 space-y-4'>
      <div className='flex flex-col gap-2'>
        <LabelRequired>
          Raison du refus
        </LabelRequired>
        <ControlledSelect
          disabled={isSubmitting}
          control={control}
          rules={{ required: 'Requis' }}
          name={nameof<TFormData>('state')}
          placeholder='Selectionner la raison'
          options={getSelectOptions('VerificationStateEnum')} />
      </div>
      <div className='flex flex-col gap-2'>
        <LabelRequired>
          Commentaire
        </LabelRequired>
        <ControlledTextarea
          disabled={isSubmitting}
          control={control}
          placeholder={'Ajouter votre commentaire'}
          name={nameof<TFormData>('comment')}
          rules={{ required: 'Requis' }}
          rows={3} />
      </div>
    </div>
  );

};

export default FormCommentReviewBody;
